// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareDevices2D_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 2H0V18H24V2ZM22 4H2V16H22V4ZM8 20H16L17 22H7L8 20ZM10.6582 12.1934H7.68945C7.68945 12.1022 7.72201 12.0062 7.78711 11.9053C7.85221 11.8044 7.9401 11.7018 8.05078 11.5977C8.16146 11.4902 8.28841 11.3828 8.43164 11.2754C8.57812 11.1647 8.72949 11.054 8.88574 10.9434C9.11686 10.7839 9.33984 10.6195 9.55469 10.4502C9.76953 10.2777 9.95833 10.0889 10.1211 9.88379C10.2871 9.67871 10.4189 9.45085 10.5166 9.2002C10.6175 8.94954 10.668 8.66309 10.668 8.34082C10.668 8.03809 10.6159 7.76465 10.5117 7.52051C10.4108 7.27311 10.2627 7.06315 10.0674 6.89062C9.87207 6.7181 9.63281 6.58626 9.34961 6.49512C9.06966 6.40072 8.75228 6.35352 8.39746 6.35352C7.63249 6.35352 6.94564 6.55046 6.33691 6.94434V8.30176C6.88704 7.82324 7.46322 7.58398 8.06543 7.58398C8.41374 7.58398 8.67253 7.66048 8.8418 7.81348C9.01107 7.96647 9.0957 8.19271 9.0957 8.49219C9.0957 8.64518 9.06966 8.79004 9.01758 8.92676C8.9655 9.06022 8.88574 9.19368 8.77832 9.32715C8.67415 9.45736 8.54395 9.58919 8.3877 9.72266C8.2347 9.85612 8.05566 9.99609 7.85059 10.1426C7.65527 10.2826 7.44857 10.4404 7.23047 10.6162C7.01562 10.7887 6.81706 10.9889 6.63477 11.2168C6.45247 11.4414 6.30111 11.6969 6.18066 11.9834C6.06022 12.2666 6 12.5872 6 12.9453V13.4727H10.6582V12.1934ZM12.2891 6.4707V13.4727H14.7695C15.8991 13.4727 16.8024 13.1471 17.4795 12.4961C18.1598 11.8451 18.5 10.9743 18.5 9.88379C18.5 7.6084 17.2565 6.4707 14.7695 6.4707H12.2891ZM13.8662 12.1934V7.75488H14.6377C15.3343 7.75488 15.8747 7.94694 16.2588 8.33105C16.6462 8.71191 16.8398 9.236 16.8398 9.90332C16.8398 10.6097 16.6445 11.168 16.2539 11.5781C15.8665 11.9883 15.3311 12.1934 14.6475 12.1934H13.8662Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareDevices2D is a generated icon component.
 */
let IconHardwareDevices2D = IconHardwareDevices2D_1 = class IconHardwareDevices2D extends IconBaseElement {
    render() {
        return html `${IconHardwareDevices2D_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareDevices2D.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareDevices2D = IconHardwareDevices2D_1 = __decorate([
    customElement('zui-icon-hardware-devices-2-d')
], IconHardwareDevices2D);
export { IconHardwareDevices2D };
